import { render, staticRenderFns } from "./OnePersonOneCodeTable.vue?vue&type=template&id=c3316c02&scoped=true"
import script from "./OnePersonOneCodeTable.vue?vue&type=script&lang=js"
export * from "./OnePersonOneCodeTable.vue?vue&type=script&lang=js"
import style0 from "./OnePersonOneCodeTable.vue?vue&type=style&index=0&id=c3316c02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3316c02",
  null
  
)

export default component.exports